import { Dashboard } from "./Dashboard";
import { DashboardView } from "./DashboardView";
import { DVEvaluation } from "./DVEvaluation";
import { Reports } from "./Reports";
import { ReportsView } from "./ReportsView";

const methodist = {
  Dashboard,
  DashboardView,
  DVEvaluation,
  Reports,
  ReportsView,
}

export default methodist